import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

const GuestModal = ({ show, handleClose }) => {

   return (
      <Modal show={show} onHide={handleClose} centered>
         <Modal.Header closeButton>
            <Modal.Title className="ms-auto">Congratulations!</Modal.Title>
         </Modal.Header>
         <Modal.Body className="p-5 fs-5">
            <p className="registered-text">
               You have logged into a <b>demo account</b> as you are not registered with us.
            </p>
            <hr className='dotted-line my-4' />
            <p>
               Register now and get your account activated to get the full KidEx experience.
            </p>
            <div className="text-center mt-5">
               <Link to="/?register=true" target="_blank">
                  <Button className="btn-theme-light px-5 py-2 rounded-pill text-dark fs-6" variant="primary" onClick={handleClose}>Create account</Button>
               </Link>
            </div>
         </Modal.Body>
      </Modal>
   );
}

export default GuestModal;